import { MutableRefObject } from 'react';
import { ISubmitResponse, EPrequalDecisionResult as result } from '../../../../../../../types/shared/PrequalificationDataEntry';
import SessionStorage from '../../../../../../../utils/SessionStorage';
import usePrequalApproved from './hooks/usePreQualApproved';
import usePrequalDeclined from './hooks/usePrequalDeclined';
import usePrequalError from './hooks/usePrequalError';
import usePrequalMultiAccount from './hooks/usePrequalMultiAccount';

export default function useHandleSubmitResponse(submittingStateRef: MutableRefObject<boolean>) {
    const { approvedFlow } = usePrequalApproved();
    const { declinedFlow } = usePrequalDeclined();
    const { errorFlow } = usePrequalError();
    const { multiAccountFlow } = usePrequalMultiAccount();

    // TODO: Type `data`
    const submitResponseHandler = async (data: ISubmitResponse) => {
        
        await SessionStorage.setCipherWithCurrentScope('prequalResponse', data);

        switch (data.PrequalDecisionResult) {
            case result.APPROVED:
                approvedFlow(data);
                break;
            case result.DECLINED_WITH_E_SIGN_CREDIT:
            case result.DECLINED_WITH_E_SIGN_CREDIT_NO_SCORE:
            case result.DECLINED_WITH_E_SIGN_NON_CREDIT:
            case result.DECLINED_WITH_E_SIGN_MLA:
            case result.FAILED_SUSPICIOUS_FRAUD:
                declinedFlow(data);
                break;
            case result.ERROR:
                errorFlow(data, submittingStateRef);
                break;
            case result.PREQUAL_MULTI_ACCT_APPROVED:
                multiAccountFlow(data);
                break;
            default:
                SessionStorage.remove('prequalResponse');
                break;
        }
    };

    return {
        submitResponseHandler,
    };
}
